export const SUPPORTED_LANGUAGES = ["en", "ar", "tr"];

export function getLanguageFromPath(pathname) {
  const segment = pathname.split("/").filter(Boolean)[0];
  return segment === "ar" || segment === "tr" ? segment : "en";
}

export function getBasePath(pathname) {
  const language = getLanguageFromPath(pathname);
  if (language === "en") return pathname || "/";

  const withoutLanguage = pathname.replace(new RegExp(`^/${language}(?=/|$)`), "");
  return withoutLanguage || "/";
}

export function localizedPath(pathname, language) {
  const basePath = getBasePath(pathname);
  if (language === "en") return basePath;
  return basePath === "/" ? `/${language}` : `/${language}${basePath}`;
}
